import {
	Box,
	Grid,
	Stack,
	Typography,
	CardContent,
	InputAdornment,
	IconButton,
	Snackbar,
	CircularProgress,
	MenuItem,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	DialogContentText,
	TextField,
	Alert
} from "@mui/material";
import React from "react";
import { useState, useEffect, useRef } from "react";
import "./login.scss";
import leftImage from "../../assets/loginImage.svg";
import logoColor from "../../assets/logoColor.svg";
import { StyledTextBox } from "../../components/ui/TextBox";
import { StyledCard } from "../../components/ui/Cards";
import { ContainedButton } from "../../components/ui/Buttons";
import {
	GenerateOtpCode,
	GetBusinessList,
	OnboardingLogin,
	RequestAccessToken,
	VerifyOtpCode,
} from "../../services/auth.services";
import { NavLink, useNavigate } from "react-router-dom";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// import Checkbox from "@mui/material/Checkbox";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
// import { StyledCheckboxes } from "../../components/ui/Checkbox";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LoadingBox } from "../../components/ui/Box";
import AlertSnackbar from "../../components/shared/notifications/AlertSnackBar";
import { FE_BASE_URL } from "../../utils/constants";
import { StyledTextBoxv2 } from "../../components/ui/TextBox";
import { LightBlueContainedButton, TextButton } from "../../components/ui/Buttons";

export default function Login() {
	const [values, setValues] = useState({
		username: "",
		password: "",
	});
	const [showPassword, setShowPassword] = useState(false);
	const [checkPassword, setCheckPassword] = useState(false);
	const [checkUserName, setCheckUserName] = useState(false);

	const [snackBarSuccess, setSnackBarSuccess] = useState(false);
	const [snackBarAlert, setSnackBarAlert] = useState(false);
	const [snackBarAlertMessage, setSnackBarAlertMessage] = useState('');
	const [amazonCallbackUri, setAmazonCallbackUri] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [openModel, setOpenModel] = useState(false);
	const [otpResponse, setOtpResponse] = useState('');
	const [openOtpModal, setOpenOtpModal] = useState(false);
	const [businessList, setBusinessList] = useState([]);
	const [selectedBusiness, setSelectedBusiness] = useState('');
	const inputsRef = useRef([]);
	const [otp, setOtp] = useState(Array(6).fill(""));
	const [onboardingStep, setOnboardingStep] = useState('');
	const emailInputRef = useRef(null);

	useEffect(() => {
		setIsLoading(true);

		const currentUrl = window.location.href;
		const urlParams = new URLSearchParams(currentUrl.split("?")[1]);
		// Create an empty object to store parameters
		const params = {};

		// Loop through all parameters and add them to the object
		for (const [key, value] of urlParams.entries()) {
			params[key] = value;
		}

		// Log the parameters object
		setAmazonCallbackUri(params);
	}, []);

	useEffect(() => {

		if (!amazonCallbackUri) return;

		if (amazonCallbackUri.spapi_oauth_code) {
			window.location.href = decodeURIComponent(
				`${FE_BASE_URL}/onboard/consent?spapi_oauth_code=${amazonCallbackUri.spapi_oauth_code}&selling_partner_id=${amazonCallbackUri.selling_partner_id}&state=${amazonCallbackUri.state}`
			);
		} else {
			setIsLoading(false);
		}

	}, [amazonCallbackUri]);

	useEffect(() => {
		// Focus email input when login page is ready (not loading)
		if (!isLoading && emailInputRef.current) {
			setTimeout(() => {
				emailInputRef.current?.focus();
			}, 100);
		}
	}, [isLoading]);

	const matches = useMediaQuery("(min-width:900px)");

	const navigate = useNavigate();

	const handleSubmit = (event) => {
		event.preventDefault();
		let error = false;

		if (values.username === "") {
			setCheckUserName(true);
			error = true;
			setSnackBarAlert(true);
			setSnackBarAlertMessage('The email you entered is incorrect.');
		} else {
			setCheckUserName(false);
		}

		if (values.password === "") {
			setCheckPassword(true);
			error = true;
			setSnackBarAlert(true);
			setSnackBarAlertMessage('The password you entered is incorrect.');
		} else {
			setCheckPassword(false);
		}

		if (!error) {
			try {
				if (amazonCallbackUri.amazon_callback_uri && !amazonCallbackUri.amazon_callback_uri.includes('https://sellercentral.amazon.com/apps/authorize/confirm/')) {
					OnboardingLogin(values).then((data) => {
						if (data.response.status === 200) {
							data.result.then((result) => {
								localStorage.setItem('userEmail', values.username);
								window.location.href = decodeURIComponent(
									`${amazonCallbackUri.amazon_callback_uri}?amazon_state=${amazonCallbackUri.amazon_state}&selling_partner_id=${amazonCallbackUri.selling_partner_id}&version=${amazonCallbackUri.version}&state=1-${result.uniqueId}&redirect_uri=https://dev.vepay.io/onboard/consent`
								);
							});
							setSnackBarSuccess(true);
						} else if (data.response.status === 404) {
							setSnackBarAlert(true);
							setSnackBarAlertMessage('User not found.');
						} else if (data.response.status === 401) {
							setSnackBarAlert(true);
							setSnackBarAlertMessage('The email or password you entered is incorrect.');
						} else {
							setSnackBarAlert(true);
							setSnackBarAlertMessage('Somthing went wrong');
						}
					});
				} else {
					RequestAccessToken(values).then(({ response, result, error }) => {
						if (error || !response.ok) {
							let message = 'Something went wrong';

							if (response.status === 404) {
								message = 'User not found.';
							} else if (response.status === 401) {
								message = 'The email or password you entered is incorrect.';
							} else if (error) {
								message = result?.message || 'Somthing went wrong try refreshing.';
							}

							setSnackBarAlert(true);
							setSnackBarAlertMessage(message);
							return;
						}

						result.then((row) => {
							localStorage.setItem('userEmail', values.username);
							if (row.portalAdmin) {
								GetBusinessList().then((data) => {
									setBusinessList(data);
									setOpenModel(true);
								})
							} else {
								switch (row.onboardingStatus) {
									case 'PENDING_EMAIL_VERIFICATION':
										setSnackBarAlert(true);
										setSnackBarAlertMessage('Email Not Yet Verified.');
										break;
									default:
										if (values.username === "azamk@holistq.com" || values.username === "azam.kassim@habshifa.com.au") {
											localStorage.setItem('onboardingStatus', 'COMPLETE')
											setTimeout(() => navigate("/dashboard"));
										} else {
											setOnboardingStep(row.onboardingStatus)
											localStorage.setItem('onboardingStatus', row.onboardingStatus)

											// TODO: TEMP DEV FIX - Set to false before deploying to production
											const DEV_SKIP_OTP = false;

											if (DEV_SKIP_OTP || values.username === "test1@vepay.io") {
												// Skip OTP and navigate directly based on onboardingStatus
												switch (row.onboardingStatus) {
													case 'PENDING_MARKETPLACE':
														navigate("/dashboard?onboardingStatus=1");
														break;
													case 'PENDING_BUSINESS_DETAILS':
														navigate("/dashboard?onboardingStatus=2");
														break;
													case 'PENDING_BANK_DETAILS':
														navigate("/dashboard?onboardingStatus=3");
														break;
													case 'PENDING_DOCUMENTS':
														navigate("/dashboard?onboardingStatus=4");
														break;
													case 'PENDING_DOCUMENT_APPROVAL':
														navigate("/onboarding/contract");
														break;
													case 'PENDING_BUSINESS_AGREEMENT':
														navigate("/onboarding/contract");
														break;
													case 'PENDING_FINAL_APPROVAL':
														navigate("/onboarding/contract");
														break;
													default:
														setTimeout(() => navigate("/dashboard"));
												}
											} else {
												const payload = {
													email: values.username,
													flowType: 1,
													otpSendType: 0
												}
												GenerateOtpCode(payload).then(({ response, result, error }) => {
													if (error || !response.ok) {
														let message = 'Something went wrong';

														if (response.status === 404) {
															message = 'User not found.';
														} else if (response.status === 401) {
															message = 'The email you entered is incorrect.';
														} else if (response.status === 409 || result?.status === 'USER_ALREADY_EXIST') {
															message = result?.status;
														} else if (error) {
															message = result?.message || 'Somthing went wrong try refreshing.';
														}

														setSnackBarAlert(true);
														setSnackBarAlertMessage(message);
														return;
													}

													result.then((row) => {
														setOtpResponse(row.status);
														handleClickOpenOtpModal();
													});
												})
											}
										}
								}
							}

						});
					})
				};
			} catch (error) {
				setSnackBarAlert(true);
				setSnackBarAlertMessage('Somthing went wrong');
				console.error('Error', error);;
			}
		}
	};

	const handleSetBusiness = (event) => {
		setSelectedBusiness(event.target.value);
		localStorage.setItem('businessId', event.target.value.id);
		localStorage.setItem("factorStartDate", event.target.value.factorStartDate);
		localStorage.setItem("userName", event.target.value.name);
		localStorage.setItem("userType", "portalAdmin");
	}

	const handleClose = () => {
		setOpenModel(false);
	};

	const handleClickOpenOtpModal = () => {
		setTimeout(() => {
			inputsRef.current[0]?.focus();
		}, 100);
		setOpenOtpModal(true);
	};

	const handleCloseOtpModal = () => {
		setOtp(Array(6).fill(""));
		setOpenOtpModal(false);
	};

	const handleSubmitOtpModal = (e) => {
		e.preventDefault();
		const payload = {
			email: values.username,
			otpNumber: otp.join("")
		}

		if (otp.join("") === "" || otp.join("") === null) {
			setSnackBarAlert(true);
			setSnackBarAlertMessage('Something went wrong');
		} else {
			VerifyOtpCode(payload).then(({ response, result, error }) => {
				if (error || !response.ok || result === false) {
					let message = 'The OTP you entered is incorrect. Please try again.';

					if (response.status === 404) {
						message = 'User not found.';
					} else if (response.status === 401) {
						message = 'The code you entered is incorrect.';
					} else if (error) {
						message = result?.message || 'Somthing went wrong try refreshing.';
					}

					setSnackBarAlert(true);
					setSnackBarAlertMessage(message);
					return;
				}

				if (result === true) {
					setOpenOtpModal(false);
					switch (onboardingStep) {
						case 'PENDING_MARKETPLACE':
							navigate("/dashboard?onboardingStatus=1");
							break;
						case 'PENDING_BUSINESS_DETAILS':
							navigate("/dashboard?onboardingStatus=2");
							break;
						case 'PENDING_BANK_DETAILS':
							navigate("/dashboard?onboardingStatus=3");
							break;
						case 'PENDING_DOCUMENTS':
							navigate("/dashboard?onboardingStatus=4");
							break;
						case 'PENDING_DOCUMENT_APPROVAL':
							navigate("/onboarding/contract");
							break;
						case 'PENDING_BUSINESS_AGREEMENT':
							navigate("/onboarding/contract");
							break;
						case 'PENDING_FINAL_APPROVAL':
							navigate("/onboarding/contract");
							break;
						default:
							setTimeout(() => navigate("/dashboard"));
					}

				};
			})
		}
	};

	const handleChange = (e, index) => {
		let value = e.target.value;

		// ✅ Only digits allowed
		if (!/^\d$/.test(value)) {
			value = "";
		}

		const newOtp = [...otp];
		newOtp[index] = value;
		setOtp(newOtp);

		if (value && index < 5) {
			inputsRef.current[index + 1].focus();
		}
	};

	const handleKeyDown = (e, index) => {
		if (e.key === "Backspace" && !e.target.value && index > 0) {
			inputsRef.current[index - 1].focus(); // go back on delete
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const pasteData = e.clipboardData.getData("text").trim();

		if (!/^\d+$/.test(pasteData)) return; // only digits

		const pasteDigits = pasteData.slice(0, 6).split("");
		const newOtp = [...otp];

		pasteDigits.forEach((digit, i) => {
			newOtp[i] = digit;
			if (inputsRef.current[i]) {
				inputsRef.current[i].value = digit;
			}
		});

		setOtp(newOtp);

		// focus last filled box
		const lastIndex = pasteDigits.length - 1;
		if (lastIndex >= 0 && lastIndex < 6) {
			inputsRef.current[lastIndex].focus();
		}
	};

	return (
		<div className="main">
			{isLoading || (amazonCallbackUri.amazon_callback_uri && !amazonCallbackUri.amazon_callback_uri.includes('https://sellercentral.amazon.com/apps/authorize/confirm/')) ? (
				<LoadingBox>
					<CircularProgress />
				</LoadingBox>
			) : (
				<Grid container alignItems="center" justifyContent="center">
					<StyledCard className="cardMain">
						<CardContent sx={{ p: 0, "&:last-child": { pb: 0 }, overflow: "hidden" }}>
							<Grid container alignItems="stretch" justifyContent="center">
								<Grid item md={6} xs={12}>
									<Stack spacing={5} className="formContainer">
										<form onSubmit={(e) => handleSubmit(e)}>
											<Stack spacing={3}>
												<img src={logoColor} alt="logo" className="logo" />
												<Typography variant="h1">Welcome Back</Typography>
												<Stack spacing={2}>
													<Stack>
														<Typography variant="body1_light">Email</Typography>
														<StyledTextBox
															inputRef={emailInputRef}
															required
															placeholder="Email address"
															error={checkUserName}
															value={values.username}
															id="username"
															name="username"
															autoComplete="username"
															onChange={(e) =>
																setValues({ ...values, username: e.target.value })
															}
															InputProps={{
																startAdornment: (
																	<InputAdornment position="start">
																		<Person2OutlinedIcon />
																	</InputAdornment>
																),
															}}
														/>
													</Stack>
													<Stack>
														<Typography variant="body1_light">Password</Typography>
														<StyledTextBox
															required
															placeholder="Password"
															error={checkPassword}
															type={showPassword ? "text" : "password"}
															value={values.password}
															id="password"
															name="password"
															autoComplete="current-password"
															onChange={(e) =>
																setValues({ ...values, password: e.target.value })
															}
															InputProps={{
																startAdornment: (
																	<InputAdornment position="start">
																		<LockOutlinedIcon />
																	</InputAdornment>
																),
																endAdornment: (
																	<InputAdornment position="end">
																		<IconButton
																			aria-label="toggle password visibility"
																			onClick={() => setShowPassword(!showPassword)}
																			edge="end"
																		>
																			{showPassword ? (
																				<Visibility />
																			) : (
																				<VisibilityOff />
																			)}
																		</IconButton>
																	</InputAdornment>
																),
															}}
														/>
													</Stack>
												</Stack>

												<Stack>
													<ContainedButton
														variant="contained"
														type="submit"
														loading="true"
													>
														Sign In
													</ContainedButton>
												</Stack>
											</Stack>
										</form>
										<Stack spacing={2}>
											<Typography variant="body2">

												<NavLink
													to="/password/reset"
												>
													<span >Forgot Password</span>
												</NavLink>
											</Typography>
											<Typography variant="body1_light">
												New to VePay?&nbsp;
												<NavLink
													to={amazonCallbackUri?.amazon_callback_uri && amazonCallbackUri.amazon_callback_uri.includes('https://sellercentral.amazon.com/apps/authorize/confirm/') ? `/onboarding?amazonCallbackUri=${encodeURIComponent(amazonCallbackUri.amazon_callback_uri)}&amazonState=${amazonCallbackUri.amazon_state}&sellingPartnerId=${amazonCallbackUri.selling_partner_id}` : "/onboarding"}
													onClick={() => {
														localStorage.clear();
													}}
												>
													<span >Create Account</span>
												</NavLink>
											</Typography>
										</Stack>
									</Stack>
								</Grid>
								<Grid item md={6} sx={{ display: matches ? "flex" : "none", overflow: "hidden", borderRadius: "0 12px 12px 0" }}>
									<img
										src={leftImage}
										alt="Grow your business"
										style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", borderRadius: "0 12px 12px 0" }}
									/>
								</Grid>
							</Grid>
						</CardContent>
					</StyledCard>
				</Grid>
			)}
			<Snackbar
				open={snackBarSuccess}
				onClose={() => setSnackBarSuccess(false)}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				sx={{ top: "0 !important", left: "0 !important" }}
				autoHideDuration={6000}
			>
				<Box
					onClose={() => setSnackBarSuccess(false)}
					sx={{ width: "100vw", background: "#00AD47", p: 0.5 }}
				>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "100%",
							textAlign: "center",
							alignItems: "center",
							justifyContent: "center",
							color: "#FFFFFF",
						}}
					>
						<CheckCircleOutlineOutlinedIcon fontSize="small" />{" "}
						<Typography variant="body2">
							Authentification successful!
						</Typography>
					</Stack>
				</Box>
			</Snackbar>
			<AlertSnackbar
				open={snackBarAlert}
				message={snackBarAlertMessage}
				type="error"
				onClose={() => setSnackBarAlert(false)}
			/>

			<Dialog
				open={openModel}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					Select which Business Account you would like to view
				</DialogTitle>
				<DialogContent>
					<br></br>
					<Stack>
						<Typography variant="body2" color="neutral.letter_Black">
							Business Accounts
						</Typography>
						<StyledTextBoxv2
							fullWidth
							value={selectedBusiness}
							select
							// disabled={enableMarketplaceSelect}
							onChange={handleSetBusiness}
						>
							<MenuItem disabled value="placeholder">
								<em>Select Business Account</em>
							</MenuItem>
							{businessList?.filter(value => value.businessStatus === 'APPROVED').map((data, index) => (
								<MenuItem value={data} key={index}>{data.name}</MenuItem>
							))}

						</StyledTextBoxv2>
					</Stack>
					<br></br>
				</DialogContent>
				<DialogActions>
					<TextButton variant="text" onClick={handleClose}>Close</TextButton>
					<LightBlueContainedButton variant="contained" disabled={localStorage.getItem('businessId') ? false : true} onClick={() => {
						if (localStorage.getItem('businessId')) {
							handleCloseOtpModal();
							// setTimeout(() => navigate("/dashboard"));
						}
					}} autoFocus>
						Proceed
					</LightBlueContainedButton>
				</DialogActions>
			</Dialog>

			<Dialog open={openOtpModal}>
				<DialogTitle>Verify Your Identity</DialogTitle>
				<DialogContent>
					<DialogContentText>
						For your security, we’ve sent a One Time Password (OTP) to <b>{values.username}</b>.
						Please enter it below to continue.
					</DialogContentText>
					{otpResponse === 'OTP_ALREADY_EXIST' ? <Alert severity="info">An OTP was already sent. Please check your email.</Alert> : ''}
					{otpResponse === 'USER_NOT_FOUND' ? <Alert severity="error">We couldn’t find an account with this email. Please check and try again.</Alert> : ''}
					<form onSubmit={(e) => handleSubmitOtpModal(e)} id="subscription-form">
						<Stack spacing={2} mt={2}>
							<Typography variant="body2" color="neutral.letter_Black">
								Enter OTP
							</Typography>
							<Stack direction="row" spacing={2} justifyContent="center">
								{otp.map((digit, index) => (
									<TextField
										key={index}
										required
										inputRef={(el) => (inputsRef.current[index] = el)}
										type="text"
										value={digit}
										inputProps={{
											maxLength: 1,
											style: {
												textAlign: "center",
												fontSize: "1.5rem",
											},
											inputMode: "numeric",
										}}
										onChange={(e) => handleChange(e, index)}
										onKeyDown={(e) => handleKeyDown(e, index)}
										onPaste={handlePaste}
									/>
								))}
							</Stack>
						</Stack>

					</form>
				</DialogContent>
				<DialogActions>
					<TextButton variant="text" onClick={handleCloseOtpModal}>Cancel</TextButton>
					<LightBlueContainedButton variant="contained" type="submit" form="subscription-form" disabled={otp.includes("")}>
						continue
					</LightBlueContainedButton>
				</DialogActions>
			</Dialog>
		</div>
	);
}
